import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { bannerHeight, lightGray } from '../variables'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import * as vars from '../variables.js'
import { Auth } from 'aws-amplify'
import { AuthContext } from '../containers/Routes'
import { Menu, Grommet } from 'grommet'
import { Redirect } from 'react-router-dom'
import theme from '../theme'

const Container = styled.div`
  background-color: white;
  border-bottom: 1px solid ${lightGray};
  box-shadow: 0 1px 3px ${lightGray};
  height: ${bannerHeight};
  width: 100%;
  box-sizing: border-box;
  padding: 20px 30px;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
`

const Logo = styled.div`
  height: 50px;

  img {
    height: 50px;
  }
`

const Logout = styled.div`
  align-self: center;
  font-weight: bold;
  color: ${vars.blue};

  :hover {
    cursor: pointer;
    color: ${vars.lightBlue};
    transform: scale(1.1);
  }
`

const removeSession = async authContext => {
  authContext.auth.signOut()
  await Auth.signOut()
  window.location.reload()
}

const InfoIcon = styled.div`
  align-self: center;
  font-size: 30px;
  margin-right: ${props => (props.admin ? '0px' : '30px')};

  :hover {
    cursor: pointer;
    color: ${vars.lightBlue};
    transform: scale(1.1);
  }
`

const RightBanner = styled.div`
  display: flex;
  justify: end;
`

function Banner(props) {
  const authContext = useContext(AuthContext)
  const [redirect, setRedirect] = useState(null)

  return (
    <Grommet theme={theme}>
      <Container>
        {authContext.admin ? (
          <Menu
            items={[
              { label: 'Voting', onClick: () => setRedirect('/') },
              { label: 'Ranking', onClick: () => setRedirect('/ranking') },
              { label: 'Admin', onClick: () => setRedirect('/admin') },
              { label: 'Logout', onClick: () => removeSession(authContext) },
            ]}
          ></Menu>
        ) : null}
        <Logo>
          <img alt="logo" src="https://www.illumio.com/hubfs/illumio_logo_color_svg-164x40.svg"></img>
        </Logo>
        <RightBanner>
          <InfoIcon admin={authContext.admin}>
            <FontAwesomeIcon icon={faInfoCircle} color={vars.blue} onClick={props.handleInfoClick} />
          </InfoIcon>
          {authContext.admin ? null : <Logout onClick={() => removeSession(authContext)}>Logout</Logout>}
        </RightBanner>
      </Container>
      {redirect ? <Redirect to={redirect} /> : null}
    </Grommet>
  )
}

export default Banner
